<template>
  <div class="btn_class">
    {{texto}}
  </div>

</template>

<script>
export default {
  name: 'BtnAlternativoTransparente',
  props: {
    texto: String,
  }
}
</script>

<style scoped lang="scss">
.btn_class {
  /*background-color: var(--primary-color-1);*/
  color: var(--color-texto-principal-claro);
  padding: 10px;
  border-radius: 6px;
  cursor: pointer;
}
.btn_class:hover{
  color: var(--color-texto-principal-oscuro);
}
</style>
